/* FAV v30 — KKTC ödeme ön doldurma
 * Ödemeye geçmeden önce sepetin alıcı kimliğine CY + posta kodu 9900 yazar
 * (tokensiz Storefront API) ve dönen checkoutUrl'e gider.
 * Her hata/zaman aşımında (2.5 sn) normal ödeme yoluna devam eder.
 */
(function () {
  if (window.__favCheckoutPrefill) return;
  window.__favCheckoutPrefill = true;

  var API = '/api/2026-04/graphql.json';
  var TIMEOUT_MS = 2500;
  var LANGS = { tr: 'TR', en: 'EN', ru: 'RU', el: 'EL' };
  var SELECTOR = 'button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]';
  var bypass = false;

  function language() {
    var l = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'tr').slice(0, 2).toLowerCase();
    return LANGS[l] || 'TR';
  }

  function withTimeout(promise, ms) {
    return new Promise(function (resolve, reject) {
      var t = setTimeout(function () { reject(new Error('timeout')); }, ms);
      promise.then(function (v) { clearTimeout(t); resolve(v); }, function (e) { clearTimeout(t); reject(e); });
    });
  }

  function prefill() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.token || !cart.item_count) throw new Error('empty');
        var query = 'mutation FavPrefill($id: ID!, $b: CartBuyerIdentityInput!) @inContext(country: CY, language: ' + language() + ') {' +
          ' cartBuyerIdentityUpdate(cartId: $id, buyerIdentity: $b) { cart { checkoutUrl } userErrors { message } } }';
        return fetch(API, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            query: query,
            variables: {
              id: 'gid://shopify/Cart/' + cart.token,
              b: { countryCode: 'CY', deliveryAddressPreferences: [{ deliveryAddress: { country: 'CY', zip: '9900' } }] }
            }
          })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('api'); return r.json(); })
      .then(function (json) {
        var d = json && json.data && json.data.cartBuyerIdentityUpdate;
        if (!d || (d.userErrors && d.userErrors.length) || !d.cart || !d.cart.checkoutUrl) throw new Error('api');
        return d.cart.checkoutUrl;
      });
  }

  document.addEventListener('click', function (event) {
    if (bypass || event.defaultPrevented) return;
    if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var el = event.target && event.target.closest ? event.target.closest(SELECTOR) : null;
    if (!el || el.disabled || el.getAttribute('aria-disabled') === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    el.setAttribute('aria-busy', 'true');

    withTimeout(prefill(), TIMEOUT_MS).then(function (url) {
      window.location.href = url;
    }).catch(function () {
      bypass = true;
      el.removeAttribute('aria-busy');
      if (el.tagName === 'A') {
        window.location.href = el.href;
      } else {
        el.click();
      }
    });
  }, true);
})();
